import { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtOdds } from "@/lib/odds";
import { useSlip } from "@/context/SlipContext";

const cache = {};

export function AltLineLadder({ leg }) {
  const { swap } = useSlip();
  const [busy, setBusy] = useState(false);
  if (leg.market !== "Player Prop" && leg.market !== "Alt Line") return null;
  if (!/(Over|Under) \d/.test(leg.selection)) return null;

  const move = async (dir) => {
    setBusy(true);
    try {
      const key = `${leg.event_id}|${leg.selection}`;
      let ladder = cache[key];
      if (!ladder) {
        ladder = (await api.get(`/picks/${leg.pick_id}/ladder`)).data.rungs;
        ladder.forEach((r) => (cache[`${leg.event_id}|${r.pick.selection}`] = ladder));
      }
      const idx = ladder.findIndex((r) => r.pick.selection === leg.selection);
      const next = ladder[idx + dir];
      if (!next) return toast.message(dir > 0 ? "Already at the highest line" : "Already at the lowest line");
      swap(leg.pick_id, next.pick);
      toast.success(`${next.pick.selection} · ${fmtOdds(next.pick.odds)}`);
    } catch (e) {
      toast.error(errMsg(e, "No alternate lines"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <span className="flex flex-col" data-testid="alt-line-ladder">
      <button data-testid="alt-line-up" disabled={busy} onClick={() => move(1)} title="Higher line (bigger payout)" className="rounded p-0.5 text-slate-500 transition-colors hover:bg-fuchsia-500/15 hover:text-fuchsia-300"><ChevronUp size={12} /></button>
      <button data-testid="alt-line-down" disabled={busy} onClick={() => move(-1)} title="Lower line (safer)" className="rounded p-0.5 text-slate-500 transition-colors hover:bg-emerald-500/15 hover:text-emerald-300"><ChevronDown size={12} /></button>
    </span>
  );
}
